import { useAppDispatch, useAppSelector } from '../../../../app/hooks';
import { selectAmlPepRefreshBannerForOrg } from '../../../../store/investor/selectors';
import { setRefreshReportPreselectedModules, setShowRefreshReport } from '../../../../store/investor/action';
import { TabModule } from '../../../../utils/constants/commonConstants';
import { useFeatureVisibility } from '../../../../utils/useVisibilityConfig';
import { VISIBILITY_KEYS } from '../../../../utils/constants/visibilityKeys';
import { AML_PEP_SCREENING_GAP_BANNER_COPY } from '../../../RiskIndicators/RiskIndicatorConstants';
import FetchDetailsBanner from '../../DashboardModules/ManagementProfileTab/FetchDetailsBanner';
import styles from '../../Dashboard.module.scss';

function ScreeningGapBanner({ assesseeOrgId }: { assesseeOrgId: string }) {
    const dispatch = useAppDispatch();
    const showBanner = useAppSelector((state) => selectAmlPepRefreshBannerForOrg(state, assesseeOrgId));
    const { unlockAicaVisibility } = useFeatureVisibility({
        unlockAicaVisibility: VISIBILITY_KEYS.UNLOCK_AICA.ENABLED,
    });
    // .show is inverted (true = Talk-To-Us), so self-serve refresh is available when it is false.
    const canSelfServeRefresh = !unlockAicaVisibility.show;

    if (!showBanner || !canSelfServeRefresh) return null;

    const onRefreshNow = () => {
        dispatch(setRefreshReportPreselectedModules([TabModule.LEGAL_CHECKS]));
        dispatch(setShowRefreshReport(true));
    };

    return (
        <div className={styles.BannerSlot}>
            <FetchDetailsBanner
                body={AML_PEP_SCREENING_GAP_BANNER_COPY.BODY}
                ctaLabel={AML_PEP_SCREENING_GAP_BANNER_COPY.CTA_LABEL}
                onFetchDetails={onRefreshNow}
                className={styles.Banner}
            />
        </div>
    );
}

export default ScreeningGapBanner;
